import gql from 'graphql-tag';

export default gql`
  mutation addSectionToChannel($section: SectionInput!) {
    addSectionToChannel(section: $section) {
      _id
    }
  }
`;
